module.exports = __webpack_public_path__ + "img/main-logo.4798b714.jpeg";